import React from 'react';
import './Spinner.css';

function Spinner({color = 'white'}) {
    return (
        <div className="lds-ellipsis">
            <div style={{backgroundColor: color}}/>
            <div style={{backgroundColor: color}}/>
            <div style={{backgroundColor: color}}/>
            <div style={{backgroundColor: color}}/>
        </div>
    );
}

export default Spinner;
